export default __webpack_public_path__ + "static/media/Scratch.21e82922.png";